function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameWizardTemplate = require('./wizard.template.js');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay.js');

//
// {
//    game   : module_name
//    league : league_obj { id , name , mod }
// }
//
var GameWizard = /*#__PURE__*/function () {
  function GameWizard(app, mod) {
    var _this = this;
    var game_mod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, GameWizard);
    this.app = app;
    this.mod = mod;
    this.game_mod = game_mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.obj = obj;
    app.connection.on('arcade-launch-game-wizard', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        var _game_mod, c, link;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(obj !== null && obj !== void 0 && obj.game)) {
                _context.n = 5;
                break;
              }
              _game_mod = _this.app.modules.returnModuleByName(obj.game);
              if (!_game_mod) {
                _context.n = 4;
                break;
              }
              if (!_game_mod.is_teaser) {
                _context.n = 3;
                break;
              }
              c = confirm("Do you want to install this game? This will take you to the app download site:");
              if (!c) {
                _context.n = 2;
                break;
              }
              link = _game_mod.link;
              if (!(link != "")) {
                _context.n = 1;
                break;
              }
              navigateWindow(link, 300);
              return _context.a(2);
            case 1:
              return _context.a(2);
            case 2:
              return _context.a(2);
            case 3:
              //
              // We do a little check that if we already have a game in the options,
              // we prompt them to continue that one instead of creating a new game
              //
              if (_game_mod.doWeHaveAnOngoingGame()) {
                if (obj.skip) {
                  navigateWindow("/".concat(_game_mod.returnSlug(), "/"));
                } else {
                  console.info('arcade-launch-game-wizard found existing game', _game_mod.game);
                  app.connection.emit('arcade-continue-game-from-options', _game_mod);
                }
              } else {
                //Launch game wizard
                _this.game_mod = _game_mod;
                _this.obj = obj;
                _this.render();
              }
              _context.n = 5;
              break;
            case 4:
              console.error('arcade-launch-game-wizard -- game module not found!', obj);
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  return _createClass(GameWizard, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$obj;
      //
      // Create the game wizard overlay
      //  & set a callback to remove the advanced options overlay if we change our mind about creating a game
      //
      if (this.mod.debug) {
        console.debug('ARCADE: render game-wizard for: ', JSON.parse(JSON.stringify(this.obj)));
      }
      this.overlay.show(GameWizardTemplate(this.game_mod, this.obj), function () {
        if (_this2.meta_overlay) {
          _this2.meta_overlay.remove();
        }
      });
      this.overlay.setBackground(this.game_mod.respondTo('arcade-games').image);

      //Test if we should include Advanced Options
      var advancedOptions = this.game_mod.returnAdvancedOptions();
      if (!advancedOptions) {
        if (document.querySelector('.arcade-wizard-advanced-text')) {
          document.querySelector('.arcade-wizard-advanced-text').style.visibility = 'hidden';
        }
      } else {
        var accept_button = "<div id=\"game-wizard-advanced-return-btn\" class=\"game-wizard-advanced-return-btn button saito-button-primary\">Accept</div>";
        if (!advancedOptions.includes(accept_button)) {
          advancedOptions += accept_button;
        }
        advancedOptions = "<div id=\"advanced-options-overlay-container\">".concat(advancedOptions, "</div>");
        this.meta_overlay = new SaitoOverlay(this.app, this.mod, false, false); // Have to manually delete when done
        this.meta_overlay.show(advancedOptions);
        this.meta_overlay.hide();
      }

      //Hook for Crypto module (if installed) to add button to attach functionality
      this.app.modules.renderInto('#arcade-advance-opt');
      this.attachEvents();
      if ((_this$obj = this.obj) !== null && _this$obj !== void 0 && _this$obj.skip) {
        if (this.game_mod.maxPlayers === 1) {
          if (!this.game_mod.returnSingularGameOption() && !advancedOptions) {
            var btn = document.querySelector('.game-invite-btn');
            if (btn) {
              btn.click();
            }
          }
        }
      }
    }

    //
    // Note: mod = Arcade
    //
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      if (document.querySelector('.saito-multi-select_btn')) {
        document.querySelector('.saito-multi-select_btn').addEventListener('click', function (e) {
          e.currentTarget.classList.toggle('showAll');
        });
      }

      //
      // Display Advanced Options Overlay
      //
      var advancedOptionsToggle = document.querySelector('.arcade-wizard-advanced-text');
      if (advancedOptionsToggle) {
        advancedOptionsToggle.onclick = function (e) {
          _this3.meta_overlay.show();
          _this3.game_mod.attachAdvancedOptionsEventListeners();
          _this3.meta_overlay.blockClose('#game-wizard-advanced-return-btn');
          if (document.getElementById('game-wizard-advanced-return-btn')) {
            document.querySelector('.game-wizard-advanced-return-btn').onclick = function (e) {
              _this3.meta_overlay.hide();
            };
          }
        };
      }

      //
      // Display Rules Overlay
      //
      if (document.getElementById('game-rules-btn')) {
        document.getElementById('game-rules-btn').onclick = function () {
          var rules_overlay = new SaitoOverlay(_this3.app, _this3.mod);
          rules_overlay.show(_this3.game_mod.returnGameRulesHTML());
        };
      }

      //
      // create game
      //
      Array.from(document.querySelectorAll('.game-invite-btn')).forEach(function (gameButton) {
        gameButton.addEventListener('click', /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var options, gameType;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  e.stopPropagation();
                  options = _this3.getOptions();
                  gameType = e.currentTarget.getAttribute('data-type');
                  _this3.overlay.remove();
                  if (!(gameType == 'private')) {
                    _context2.n = 1;
                    break;
                  }
                  _context2.n = 5;
                  break;
                case 1:
                  if (!(gameType == 'single')) {
                    _context2.n = 2;
                    break;
                  }
                  _this3.mod.makeGameInvite(options, 'private', _this3.obj);
                  return _context2.a(2);
                case 2:
                  if (!(gameType == 'direct')) {
                    _context2.n = 3;
                    break;
                  }
                  _context2.n = 5;
                  break;
                case 3:
                  if (!(gameType == 'async')) {
                    _context2.n = 5;
                    break;
                  }
                  if (!(options['game-wizard-players-select'] > 2)) {
                    _context2.n = 4;
                    break;
                  }
                  salert('Asynchronous game creation is experimental and assumes there are only two players!');
                  return _context2.a(2);
                case 4:
                  options.async_dealing = 1;
                  gameType = 'private';
                  _context2.n = 5;
                  break;
                case 5:
                  _this3.mod.makeGameInvite(options, gameType, _this3.obj);
                case 6:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = {};
      document.querySelectorAll('#advanced-options-overlay-container input, #advanced-options-overlay-container select, .arcade-wizard input, .arcade-wizard select').forEach(function (element) {
        if (element.name) {
          if (element.type == 'checkbox') {
            if (element.checked) {
              options[element.name] = 1;
            }
          } else if (element.type == 'radio') {
            if (element.checked) {
              options[element.name] = element.value;
            }
          } else {
            options[element.name] = element.value;
          }
        }
      });
      if (document.querySelector('.game-wizard-crypto-hook')) {
        var _hook$dataset, _hook$dataset2;
        var hook = document.querySelector('.game-wizard-crypto-hook');
        if ((_hook$dataset = hook.dataset) !== null && _hook$dataset !== void 0 && _hook$dataset.ticker && (_hook$dataset2 = hook.dataset) !== null && _hook$dataset2 !== void 0 && _hook$dataset2.amount) {
          options['crypto'] = hook.dataset.ticker;
          options['stake'] = hook.dataset.amount;
          if (hook.dataset.match != undefined) {
            options['stake'] = {
              min: parseFloat(hook.dataset.match)
            };
            options['stake'][this.mod.publicKey] = parseFloat(hook.dataset.amount);
          }
        }
      }
      if (this.mod.debug) {
        console.debug('ARCADE game-wizard -- reading options from HTML: ', JSON.parse(JSON.stringify(options)));
      }
      if (this.meta_overlay) {
        this.meta_overlay.remove();
      }

      // Check for open table here
      if (options['game-wizard-players-select'] == 'open-table') {
        options['open-table'] = 1;
        options['game-wizard-players-select'] = 2;
        options['game-wizard-players-select-max'] = 6;
      }
      return options;
    }
  }]);
}();
module.exports = GameWizard;